/**
 * KCPSユーザーID(ニフティクラウドID)のバリデーション.
 * 半角英大文字3桁+半角数字5桁で入力されること */

export default {
  validate(value: string | undefined | null): boolean {
    if (!value) return true;

    const pattern = /^[A-Z]{3}[0-9]{5}$/;

    return pattern.test(value);
  },
};
